export default "https://cdn-static.gokick.com/assets/16eea26e4b02b6fb7531e57480884e04972270e8/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";